import React, { useState } from 'react';
import { Button, Col, Form, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
// import {TextField} from '@material-ui/core';
import {MdRemoveRedEye} from 'react-icons/md';
import {ImGoogle} from 'react-icons/im';
import {FaFacebookF} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './SignIn.css';

function SignIn() {
   const [clicked, setClicked]= useState(true);

   const [logData, setLogData]= useState({
       email:'',
       password:''
   })

    function handleShow(){
        setClicked(!clicked)
    }

    return (
        <div className='Background2'>
            <Form className='SignUp-Container2'>
                <h3 style={{textAlign:'center'}} >Sign-In</h3>
                <FormGroup>
                    <FormLabel>Email</FormLabel>
                    <FormControl type='email' value={logData.email} size='md' onChange={(e)=>setLogData({...logData,email:e.target.value})} placeholder='eg: Vincentk@gmail.com' />
                </FormGroup>
                <FormGroup>
                    <FormLabel>Password</FormLabel>
                    <FormControl value={logData.password} type={clicked?'password':'text'} size='md' onChange={(e)=>setLogData({...logData,password:e.target.value})}  />
                    <MdRemoveRedEye className='eye' onClick={handleShow} />
                </FormGroup>
                <div className='sbtlogin'>
                    <Button className='loginBtn' type='submit'>Login</Button>
                </div>
                <div className='forgotwrap'>
                    <Link className='forgotLink' to=''>Forgot password?</Link>
                </div>
                <div className='social'>
                    
                    <Button className='GoogleBtn'><ImGoogle className='GoogleIcon' /> SignIn with Google</Button>
                    <Button className='FacebookBtn'><FaFacebookF className='FacebookIcon' /> SignIn with Facebook</Button>
                </div>
                <hr/>
                <div>
                    <span>New user?</span>
                    <Link to='/signup' style={{color:'green',paddingLeft:'5px'}} >signup</Link>
                </div>
            </Form>
        </div>
    )
}

export default SignIn
